import React from 'react';
import Dialog from 'material-ui/Dialog';
import { Link } from 'react-router-dom';
import '../Alert/alert.css';

const UploadSucess = ({ isDialogOpen, closeDialog }) => (
  <Dialog
    actions={
      <div className="buttons-div">
        <Link to="/login">
          <button type="button" className="alert-button" onClick={closeDialog}>
            DONE
          </button>
        </Link>
      </div>
    }
    modal
    open={isDialogOpen}
    paperProps={{ style: { borderRadius: '4px' } }}>
    <p style={{ textAlign: 'center' }}>
      Thank you for submitting your documents. We will reach out to you as soon as possible.
    </p>
  </Dialog>
);

export default UploadSucess;



// WEBPACK FOOTER //
// ./src/components/MissingDocs/UploadSucess.js